import {
  type AudioStreamStartResult,
  type OnAudioDataAvailable,
  AUDIO_BLOB_MILLIS,
  MediaRecorderMeta,
  WEBM_PCM_MIME_TYPE,
} from "../models/AudioStream.interface";
import { getLatestHalfSecondRawStream, initRawStreamAnalyzer } from "./rawStreamSetup";

/**
 * Effectively tees the output of the audio element, to get the desired histogram side effect (callback) to happen.
 *
 * Caution: can only be used once per audioElement.  Once the nodes are connected, unconnect/reconnect is hard.
 */
export function streamLatestSavedAudio(
  audioElement: HTMLMediaElement,
  onDataAvailable: OnAudioDataAvailable,
  meta: MediaRecorderMeta
): AudioStreamStartResult {
  try {
    const audioCtx = new AudioContext({ sampleRate: 48000 });
    const originalDest = audioCtx.destination;
    const source = audioCtx.createMediaElementSource(audioElement);
    const streamableDestinationNode = audioCtx.createMediaStreamDestination();
    streamableDestinationNode.channelCountMode = "explicit";
    streamableDestinationNode.channelCount = 1;

    const analyzer = audioCtx.createAnalyser();
    if (meta.streamFormat === "RAW") {
      initRawStreamAnalyzer(analyzer);
      source.connect(analyzer);
    }
    source.connect(streamableDestinationNode);
    source.connect(originalDest); // reconnect speaker output, the above stomped it

    const mediaRecorder = new MediaRecorder(streamableDestinationNode.stream, {
      mimeType: meta.streamFormat === "WEBM_PCM" ? WEBM_PCM_MIME_TYPE : undefined,
    });
    // const source = audioCtx.createMediaStreamSource(mediaRecorder.stream);
    mediaRecorder.ondataavailable = (e: BlobEvent) => {
      let rawBlob = undefined;
      if (meta.streamFormat === "RAW") {
        rawBlob = getLatestHalfSecondRawStream(analyzer);
      }
      onDataAvailable({ pcmBlob: e.data, rawBlob, sampleRate: audioCtx.sampleRate });
    };
    mediaRecorder.onerror = (e: any) => {
      console.warn(`mediaRecorder id=${meta.id} error=${e}`);
    };
    mediaRecorder.start(AUDIO_BLOB_MILLIS);
    return { mediaRecorder };
  } catch (error) {
    return {
      error: `stream capture error: ${error}`,
    };
  }
}
